import React, { ReactNode } from 'react';
import { createContext } from 'react';
import axios from 'axios';
import { ICities, IStates } from '../interfaces/IIbge';

interface IbgeContextProviderProps {
  children: ReactNode;
}

interface IbgeContextProps {
  getCities: (estado: string) => Promise<ICities>;
  getStates: () => Promise<IStates>;
  getAllCities: () => Promise<ICities>;
}

export const IbgeContext = createContext({} as IbgeContextProps);

export function IbgeContextProvider(props: IbgeContextProviderProps) {
  async function getCities(estado: string): Promise<ICities> {
    try {
      const response = await axios.get(
        `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estado}/municipios`
      );
      return response.data;
    } catch (error) {
      console.log('getCities error: ', error);
      throw error;
    }
  }

  async function getAllCities(): Promise<ICities> {
    try {
      const response = await axios.get(
        'https://servicodados.ibge.gov.br/api/v1/localidades/municipios'
      );
      return response.data;
    } catch (error) {
      console.log('getAllCities error: ', error);
      throw error;
    }
  }

  async function getStates(): Promise<any> {
    try {
      const response = await axios.get(
        'https://servicodados.ibge.gov.br/api/v1/localidades/estados'
      );

      if (response.data.error) {
        throw response.data.message;
      }

      const sortedStates = response.data.sort((a, b) =>
        a.nome.localeCompare(b.nome)
      );

      return sortedStates;
    } catch (error) {
      console.log('getStates error: ', error);
      throw error;
    }
  }

  return (
    <IbgeContext.Provider
      value={{
        getCities,
        getStates,
        getAllCities,
      }}
    >
      {props.children}
    </IbgeContext.Provider>
  );
}
